import { useEffect, useState } from "react";

import { getSessions, type SessionListItem } from "../lib/api";
import PixelField from "../components/PixelField";
import ScreenHead from "../components/ScreenHead";
import SessionCard from "../components/SessionCard";

interface Props {
  onStart: () => void;
  onOpen: (clientId: string) => void;
}

export default function History({ onStart, onOpen }: Props) {
  const [items, setItems] = useState<SessionListItem[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getSessions()
      .then(setItems)
      .catch((e) => setError(e instanceof Error ? e.message : String(e)));
  }, []);

  return (
    <div className="screen">
      <ScreenHead eyebrow="История" title="Тренировки" seed={5} />

      {error && <p className="lead lead--error">{error}</p>}
      {!error && items === null && (
        <div className="stack">
          {[0, 1, 2].map((i) => (
            <div key={i} className="skeleton skeleton--card" />
          ))}
        </div>
      )}

      {items?.length === 0 && (
        <div className="empty">
          <div className="empty__art">
            <PixelField seed={3} />
          </div>
          <p className="empty__title">Пока ничего</p>
          <p className="lead">
            Здесь появятся проведённые тренировки: объём, длительность и все
            подходы. Начни первую — дальше приложение начнёт предлагать веса.
          </p>
          <button className="button" onClick={onStart}>
            Начать тренировку
          </button>
        </div>
      )}

      {items && items.length > 0 && (
        <div className="stack">
          {items.map((s) => (
            <SessionCard key={s.client_id} session={s} onOpen={onOpen} />
          ))}
        </div>
      )}
    </div>
  );
}
